import {
  HoopsApi,
  ControlcenterMelcoModelsHoopListItem,
  useAPIQuery,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";

export const useManageHoops = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQueryChange,
    searchQuery,
  } = useTable<ControlcenterMelcoModelsHoopListItem>({
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    HoopsApi,
    ["managehoops", searchQuery, currentPage, pageSize, filters, sortBy()],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));

      let response = await api.hoopsSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText:
          filters?.searchText && !isEmpty(filters.searchText)
            ? filters.searchText
            : undefined,
        productList:
          filters?.products && !isEmpty(filters?.products)
            ? filters.products.join(",")
            : undefined,
        publishState: ALL_PUBLISHED_STATES,
        categoryList:
          filters?.categories && !isEmpty(filters?.categories)
            ? filters.categories.join(",")
            : undefined,
        machineList:
          filters?.machines && !isEmpty(filters?.machines)
            ? filters.machines.join(",")
            : undefined,
      });

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        // keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    filtersChange,
    sorter,
    searchQueryChange,
    errorComponent,
    searchQuery,
    ...query,
  };
};
